module.exports = __webpack_public_path__ + "media/images/icon__arrow-left--rb-light-gray@3x-d292e7bf64a46b32e287cabd90a3dd3e.png";